/**
 * Activos Fijos API Service
 */
import api from './api';

const API_BASE_URL = (() => {
  const baseURL = api?.defaults?.baseURL || '/api/content';
  return baseURL.replace(/\/content\/?$/i, '/contabilidad');
})();

const activosFijosService = {
  getAll: (filters = {}) => api.get(`${API_BASE_URL}/activos-fijos/`, { params: filters }),
  getById: (id) => api.get(`${API_BASE_URL}/activos-fijos/${id}/`),
  create: (data) => api.post(`${API_BASE_URL}/activos-fijos/`, data),
  update: (id, data) => api.patch(`${API_BASE_URL}/activos-fijos/${id}/`, data),
  delete: (id) => api.delete(`${API_BASE_URL}/activos-fijos/${id}/`),
  depreciar: (id, data = {}) => api.post(`${API_BASE_URL}/activos-fijos/${id}/depreciar/`, data),
  darDeBaja: (id, data) => api.post(`${API_BASE_URL}/activos-fijos/${id}/dar_de_baja/`, data),
  resumenPorCategoria: () => api.get(`${API_BASE_URL}/activos-fijos/resumen_por_categoria/`),
};

export default activosFijosService;
